import React from 'react';
import { Box, Typography, Tooltip } from '@mui/joy';
import EastIcon from '@mui/icons-material/East';

interface HeaderTooltipProps {
	open: boolean;
	onClose: () => void;
	onNext?: () => void;
	description: string;
	actionText: string;
	children: React.ReactElement;
}

const HeaderTooltip: React.FC<HeaderTooltipProps> = ({
	open,
	onClose,
	onNext,
	description,
	actionText,
	children,
}) => {
	const handleActionClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (onNext) {
			onNext();
		} else {
			onClose();
		}
	};

	const tooltipContent = (
		<Box
			sx={{
				backgroundColor: 'success.700',
				padding: '8px 12px 6px 12px',
				gap: '2px',
			}}
		>
			{/* Description text */}
			<Typography
				level='body-sm'
				sx={{
					color: 'primary.100',
				}}
			>
				{description}
			</Typography>

			{/* Action button/text */}
			<Box
				component='button'
				onClick={handleActionClick}
				sx={{
					background: 'none',
					border: 'none',
					padding: 0,
					cursor: 'pointer',
					width: '100%',
					textAlign: 'left',
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
				}}
			>
				<Typography
					level='title-sm'
					sx={{
						color: '#fff',
					}}
				>
					{actionText}
				</Typography>
				<EastIcon sx={{ color: '#fff', fontSize: '16px' }} />
			</Box>
		</Box>
	);

	return (
		<Tooltip
			title={tooltipContent}
			open={open}
			placement='bottom-start'
			arrow
			sx={{
				'--variant-solidBg': '#0A470A',
				'--Tooltip-bgcolor': '#0A470A',
				'--Tooltip-arrowBackground': '#0A470A',
			}}
			slotProps={
				{
					root: {
						variant: 'plain',
						sx: {
							backgroundColor: 'transparent !important',
							boxShadow: 'none !important',
							border: 'none !important',
							padding: 0,
						},
					},
					arrow: {
						sx: {
							'&::before': {
								borderTopColor: '#0A470A !important',
								borderRightColor: '#0A470A !important',
							},
						},
					},
					content: {
						sx: {
							backgroundColor: 'transparent !important',
							border: 'none !important',
							padding: 0,
							boxShadow: 'none !important',
						},
					},
				} as any
			}
		>
			{children}
		</Tooltip>
	);
};

export default HeaderTooltip;
